export const devInitialAppState = {
  rightPanelPortalToElement: document.getElementById("portal_holder"),
  currentGroupPanel: "sheet",
};
